import SharedSectionMenu from 'components/shared/SectionMenu';

import { SECTIONS_MENU } from 'views/auto_form/constants';

const SectionMenu = () => {
  return (
    <SharedSectionMenu
      sections={SECTIONS_MENU}
      formStateKey="autoPersonalForm"
    />
  );
};

export default SectionMenu;
